import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SimposiosService } from '../../service/simposios.service';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from '../../service/seo.service';
import { UrlcanonicaService } from '../../service/urlcanonica.service';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-simposios',
  templateUrl: './simposios.component.html',
  styleUrls: ['./simposios.component.css']
})
export class SimposiosComponent implements OnInit {

  simposios!:any[];
  simposiosUltimo!:any[];
  simposiosPenultimo!:any[];
  newstr: any;
  url: any;
  
  RouteText : any;
  tituloseo: any;
  urlcanonicaseo: any;
  imagenseo: any;
  keywordsseo: any;
  descripcionseo: any;

  pageActual: number = 1;
  
  constructor(    
    private _simposiosService : SimposiosService,
    private router: Router,
    private meta: Meta,
    private title: Title,
    
    private _seoService: SeoService,
    private _urlcanonicaservice: UrlcanonicaService
    
  ){ 
    
    this.router.events.pipe(filter((event: any) =>  event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.RouteText = event;
      this.getSEO(event.url)
    });
    
    this.getSimposios();
    this.getUltimoSimposios();
    this.getPenultimoSimposios();
  }


  getSimposios(){
    this._simposiosService.getSimposios().subscribe((resp:any)=>{
    this.simposios=resp;
    console.log(this.simposios)
    })
  }

  getUltimoSimposios(){
    this._simposiosService.getSimposios().subscribe((resp:any)=>{
    this.simposiosUltimo=resp.reverse().slice(0,1);
    })
  }

  getPenultimoSimposios(){
    this._simposiosService.getSimposios().subscribe((resp:any)=>{
    this.simposiosPenultimo=resp.slice(0,1);
    })
  }

  getSimposioUrl(simposio: any) {
    this.newstr = simposio.urlNota.toLowerCase();
    //this.newstr = this.newstr.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    this.router.navigate(["/simposio/" + simposio.id + "/" + this.newstr]);
    // por si se necesita remplazar caractes especiales
    // this.newstr = this.newstr.replace(/[^\w\s]/gi, '');
  }

  getSEO(page: string) {
    this._seoService.getSEO(page).subscribe((resp: any) => {
      console.log(resp)
      if (resp != null) {
        this.tituloseo = resp.titulo;
        this.descripcionseo = resp.descripcion;
        this.urlcanonicaseo = resp.urlcanonica;
        this.imagenseo = resp.imagen;
  
        this._urlcanonicaservice.createCanonicalLink();
        this.title.setTitle(this.tituloseo)
        this.meta.updateTag({
          name: 'description',
          content: this.descripcionseo
        })
  
        this.meta.updateTag({
          property: 'twitter:card',
          content: 'summary'
        })
        this.meta.updateTag({
          property: 'twitter:site',
          content: '@fundacionbest'
        })
        this.meta.updateTag({
          property: 'twitter:title',
          content: 'Fundación BEST'
        })
        this.meta.updateTag({
          property: 'twitter:description',
          content: this.descripcionseo
        })
        this.meta.updateTag({
          property: 'twitter:image',
          content: this.imagenseo
        })
  
        this.meta.updateTag({
          property: 'og:url',
          content: 'https://fundacionbest.org.mx/servicios'
        })
        this.meta.updateTag({
          property: 'og:title',
          content: this.tituloseo
        })
        this.meta.updateTag({
          property: 'og:image',
          content: this.imagenseo
        })
        this.meta.updateTag({
          property: 'og:description',
          content: this.descripcionseo
        })
      }
  
    });
  }

  ngOnInit(): void {
  }

}
